import { render, staticRenderFns } from "./my-wepoints-tab.vue?vue&type=template&id=6ff6102c&scoped=true&"
import script from "./my-wepoints-tab.vue?vue&type=script&lang=ts&"
export * from "./my-wepoints-tab.vue?vue&type=script&lang=ts&"
import style0 from "./my-wepoints-tab.vue?vue&type=style&index=0&id=6ff6102c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff6102c",
  null
  
)

export default component.exports